import { LoginResponse } from '../models/commonModels';
import fetch from './fetch';

export default ({ email, password }: { email: string; password: string }): Promise<LoginResponse> =>
    fetch<LoginResponse>(
        '/token',
        {
            method: 'POST',
            body: JSON.stringify({
                username: email,
                password,
                grant_type: 'password',
                client_id: 'accounts',
            }),
        },
        { isRefreshing: 'true' }
    );
